<template>
    <div class="jihuoka">
        <div class="mark">
            <div class="tanchuang1" v-show="!isJihuo">
                <ul class="title_box">
                    <li @click="isShowCode=false" :class="isShowCode ? '' : 'active'">
                        <template v-if="isZhifou">
                            卡密激活
                        </template>
                        <template v-else>
                            激活{{cardTitle}}
                        </template>
                    </li>
                    <li @click="isShowCode=true" :class="isShowCode ? 'active' : ''" v-show="isZhifou">在线激活</li>
                </ul>
                <div class="card_box" v-show="!isShowCode">
                    <p class="neirong">
                        <input type="text" v-model="card" :placeholder="'请输入'+ cardTitle+'卡号'" class="Username" autocomplete="off">
                    </p>
                    <p class="neirong2">
                        <input type="password" v-model="password" :placeholder="'请输入'+ cardTitle + '密码'" class="Password1" autocomplete="new-password" >
                    </p>
                    <p class="warning">{{warning4}}</p>
                    <div @click="goJihuo" class="button">确定</div>
                </div>
                <div class="code_box" v-show="isShowCode">
                    <img :src="codeUrl" alt="">
                    <p>扫码完成验证，获取权限</p>
                </div>                
                <div class="close" @click="$emit('goClose')">×</div>
            </div>
            <div class="tanchuang2" v-show="isJihuo">
                <div class="tubiao"><img src="/imgs/selfAssessment/chenggong.png" alt=""></div>
                <div class="title">生涯卡激活成功</div>
                <!-- <p class="tishiyu">可使用生涯测评、选科、升学途径分析、选择决策、视频课程等升学规划功能</p> -->

                <div class="goback" @click="goBack">确定</div>
            </div>
        </div>
    </div>
</template>
<style type="text/css" lang='less' scoped>
.jihuoka{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .mark {
        position: fixed;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 100;
        background-color: rgba(51,51,51,.5);
        text-align: center;
    }
    .inner {
        width: 1200px;
        margin: 0 auto;
    }
    .tanchuang1 {
        box-sizing: border-box;
        padding: 30px 50px;
        position: absolute;
        left: 50%;
        top: 160px;
        margin-left: -245px;
        width: 490px;
        height: 364px;
        background-color: #fff;
        .title_box {
            display: flex;
            height: 54px;
            li {
                box-sizing: border-box;
                // width: 50%;
                flex: 1;
                line-height: 54px;
                border-bottom: 1px solid #e7e4e4;
                cursor: pointer;
                font-size: 18px;
                color: #333;
            }
            .active {
                border-bottom: 2px solid #156def;
                color: #156def;
            }
        }
        // 关闭返回首页
        .close {
            width: 36px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            color: #666;
            font-size: 34px;
            position: absolute;
            border-radius: 18px;
            right: 18px;
            top: 18px;
            z-index: 1;
            cursor: pointer;
        }
        .card_box {
            padding-top: 30px;
        }
        .code_box {
            padding-top: 35px;
            img {
                width: 160px;
                height: 160px;
                margin: 0 auto;
            }
            p {
                padding-top: 15px;
                font-size: 16px;
                color: #333;
            }
        }
        .Username {
            background: url(/imgs/selfAssessment/touxiang.png) no-repeat 10px center;
        }
        .Password1 {
            background: url(/imgs/selfAssessment/mima.png) no-repeat 10px center;
        }
        .title {
            text-align: center;
            font-size: 18px;
            line-height: 58px;
            color: #2c8ffc;
            border-bottom: 2px solid #2c8ffc;
            margin-bottom: 30px;
        }
        .neirong {
            height: 50px;
            input {
                box-sizing: border-box;
                width: 390px;
                height: 50px;
                padding-left: 50px;
                border: none;
                border-radius: 3px;
                border: 1px solid #e8e4e5;
            }
            margin-bottom: 25px;
        }
        .neirong2 {
            .neirong;
            margin-bottom: 0px;
        }
        .warning {
            height: 35px;
            line-height: 35px;
            font-size: 14px;
            color: red;
        }
        .button {
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 5px;
            color: #fff;
            background-color: #2c8ffc;
            cursor: pointer;

        }

    }
    .tanchuang2 {
        box-sizing: border-box;
        padding: 50px 50px 20px 50px;
        position: absolute;
        left: 50%;
        top: 120px;
        margin-left: -245px;
        width: 490px;
        height: 350px;
        background-color: #fff;
        .tubiao {
            width: 78px;
            height: 78px;
            margin: 0 auto;
            overflow: hidden;
            border-radius: 50%;
        }
        .title {
            line-height: 58px;
            font-size: 18px;
            color: #333;
            text-align: center;
        }
        .tishiyu {
            // line-height: 58px;
            font-size: 14px;
            color: #666;
            text-align: center;
            margin-bottom: 50px;
        }
        .goback {
            height: 45px;
            line-height: 45px;
            text-align: center;
            border-radius: 5px;
            color: #fff;
            background-color: #2c8ffc;
            cursor: pointer;
            border: none;
        }

    }
}
</style>
<script>
export default {
    props: [ 'isZhifou','codeUrl','cardType','pathUrl','cardTitle' ],
    data() {
        return {
            // 选科卡账号
            card: '',
            // 选科卡密码
            password: '',
            warning4: '',
            isJihuo: false,
            isShowCode: false
        }
    },
    methods: {
        getIsPayDone() {
            let token = window.sessionStorage.getItem('ymtxToken');
            // let url = '/shengyaceping';
            let url = this.pathUrl;
            let cardType = this.cardType;
            this.COMMONFNC().isPayDone(token,url,cardType)
                .then((res) =>{
                    if(res.data.code==2000) {
                        let code = res.data.data.code;
                        if(code==2) {
                            setTimeout(()=>{
                                if(this.getIsPayDone) {
                                    this.getIsPayDone();  
                                }
                            },2000)
                        }else {
                            this.$router.push(url);
                        }
                    }
                })  
                .catch((error)=> {
                    setTimeout(()=>{
                        if(this.getIsPayDone) {
                            this.getIsPayDone();  
                        }
                    },2000)
                })
        },
        // 购买生涯卡
        goJihuo() {
            var token = window.sessionStorage.getItem('ymtxToken');
            var card = this.card;
            var password = this.password;
            var _this = this;
            var cardType = this.cardType;
            var url;
            if(cardType=='B') {
                url = '/chooseSubject/bindLearningCapacityCard'
            }else {
                url = '/chooseSubject/bindChooseSubjectCard';
            }

            this.$ajax.post(this.G_uri + url,{
                token: token,
                card: card,
                password: password
            },{
                headers:{
                    token: token
                }
            })
            .then(function(res) {
                if(res.data.code == 2000) {
                    // 激活生涯卡成功显示成功弹窗
                    // _this.isJihuo = true;
                    _this.goBack();
                }else if(res.data.code == 1016) {
                    _this.$router.push('/login');
                }else {
                    _this.warning4 = res.data.msg;
                }

            })
            .catch(function(error) {
                console.log(error)
            });
        },
        // 购买成功返回进行生涯测评
        goBack() {
            // 从新跳转到生涯测评页面
            let url = this.pathUrl;
            this.$emit('goClose');
            if(url=='/learningAbility'){
                let link = null;
                if(this.$OEMdomain==='http://39.98.37.134'){
                    link = 'http://39.98.37.134:9005';
                    window.open(link + '/learningcapacitytest/#/learningAbility','_blank')
                }else{
                    window.open('/learningcapacitytest/#/learningAbility','_blank')
                }
            }else{
                let {href}=this.$router.resolve({
                  path: url
                })
                window.open(href, '_blank');
            }            
        },
    },
    mounted() {

    },
    created() {
        // this.getIsPayDone();
    },
    // beforeDestroy() {
    //     this.getIsPayDone = null;
    // }
}
</script>
